import { redirect, notFound } from "next/navigation";
import { Box, Container, Stack, Typography } from "@mui/material";
import { Cache } from "@nawar/cache";
import ApiIcon from "@mui-symbols-material/w400/DeployedCodeAccountFilledRounded";

import { cypher } from "../../service/graph-req";
import Client from "./Client";

const cache = new Cache({ ttl: 86400e3 / 2 });

export default async function Page({ params, searchParams }) {
  const [count, { tab }, query] = await Promise.all([
    getData(),
    params,
    searchParams
  ]);

  return tab === undefined ? (
    redirect(
      `/api/pricing${
        query.returnTo === undefined ? "" : `?returnTo=${query.returnTo}`
      }`
    )
  ) : ["pricing", "key", "billing"].includes(tab) === false ? (
    notFound()
  ) : (
    <Container
      maxWidth="large"
      sx={{
        gap: 4,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        pb: { compact: 2, expanded: 3 }
      }}
    >
      <LogoIcon />
      <Box width="100%">
        <Client count={count} query={query} />
      </Box>
    </Container>
  );
}

async function getData() {
  const key = "meter-size-count";
  let count = cache.get(key);

  if (count === undefined) {
    try {
      count = {};

      const [results] = await cypher(`
        CALL() {
          MATCH (model:Model)
          WHERE model.sizeName IN ['micro','xs']
          RETURN COUNT(model) AS free
        }
        CALL() {
          MATCH (model:Model)
          WHERE model.sizeName IN ['sm']
          RETURN COUNT(model) AS ten
        }
        CALL() {
          MATCH (model:Model)
          WHERE model.sizeName IN ['md','lg','xl']
          RETURN COUNT(model) AS fifty
        }
        CALL() {
          MATCH (model:Model)
          WHERE model.sizeName IN ['xxl','super']
          RETURN COUNT(model) AS enterprise
        }

        RETURN free, ten, fifty, enterprise
      `);

      const number = new Intl.NumberFormat("en-US", { notation: "compact" });
      let sum = 0;

      for (const key in results) {
        sum += Number(results[key]);

        count[`${key}Divider`] = number.format(sum).toLowerCase();
        count[key] = number.format(results[key]).toLowerCase();
      }

      cache.set(key, count);
    } catch (error) {
      console.error(error);
    }
  }

  return count;
}

export const Section = ({
  children,
  title,
  color,
  bgcolor = "var(--surface-container-color)",
  sx
}) => (
  <Stack
    p={2}
    border={1}
    spacing={2}
    bgcolor={bgcolor}
    borderColor="var(--outline-variant)"
    borderRadius="var(--shape-md-round)"
    sx={sx}
  >
    {title ? (
      <Typography variant="titleLg" component="h3" color={color}>
        {title}
      </Typography>
    ) : null}
    {children}
  </Stack>
);
const LogoIcon = () => (
  <Stack alignItems="center" pt={3} zIndex={1200} position="relative">
    <ApiIcon
      sx={{
        color: "var(--primary-color)",
        width: { compact: 64, expanded: 80 },
        height: { compact: 64, expanded: 80 }
      }}
    />
    <Typography
      fontWeight="700 !important"
      color="var(--secondary-color)"
      typography={{ compact: "headlineSm", expanded: "displayMd" }}
    >
      Model API
    </Typography>
  </Stack>
);
